<template>
<div>
  <el-card class="blocked_logs_page">
  <div >
    <h1>Live留存数据</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="curChannel.selectValue"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="language"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
      </el-select>
       <el-select
        style="width: 160px"
        v-model="country"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="userType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in userTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
     <el-select
        style="width: 160px"
        v-model="retentionType"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in retentionTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
      </el-date-picker>
    </div>
    <div class="user-options clearfix">
      <el-select
        style="width: 160px"
        v-model="isPay"
        placeholder
      >
        <el-option
            v-for="(item, itemIndex) in isPays"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
      </el-select>
      <el-select
        style="width: 160px"
        v-model="event"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in events"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
        
      </el-select>
      <el-input v-if="eventValue" v-model="eventValueStart" type="number" style="width:150px" placeholder="初始值"></el-input>
      <el-input v-if="eventValue" v-model="eventValueEnd" type="number" style="width:150px" placeholder="最终值"></el-input>
      <el-select
        style="width: 160px"
        v-model="contrastType"
        placeholder
        v-if="eventValues"
      >
        <el-option
          v-for="(item, itemIndex) in contrastTypes"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
        
      </el-select>
      <el-input v-if="eventValues" v-model="contrastValue" type="number" style="width:150px" placeholder="输入次数"></el-input>
      <el-button type="primary" @click="get_list" :loading="login1">查询</el-button>
      <el-button type="primary" @click="dwnDayChatDetai">下载</el-button>
    </div>
    <el-row>
      <el-table
        :data="tableList"
        border
        height="60vh"
        v-loading="login1"
      >
        <el-table-column align="center" fixed prop="date" label="时间"   sortable>
        </el-table-column>
        <el-table-column align="center" prop="day1" label="第一日（人数）"   sortable>
        </el-table-column>
        <el-table-column align="center" prop="day2" label="次留"   sortable>
        </el-table-column>
        <el-table-column align="center" prop="day3" label="3日"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="day7" label="7日"  sortable>
        </el-table-column>
        <el-table-column align="center" prop="day30" label="30日"  sortable>
        </el-table-column>
      </el-table>
    </el-row>
      <!-- <el-row >
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
  </div>
  </el-card>
  <el-card class="blocked_logs_page">
     <div>
       <el-select
        style="width: 100px"
        v-model="tiem"
        placeholder
      >
        <el-option
          v-for="(item, itemIndex) in tiems"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
        
      </el-select>
       <el-button type="primary" @click="lineOptionBuild_s" :loading="login1">查询</el-button>
     </div>
    <CustomLine :options="lineOptions"
      class="user-options"
      v-loading="login1"
      ></CustomLine>
  </el-card>
  </div>
</template>

<script>
import CustomLine from '@/components/myecharts.vue'
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  components: {
    CustomLine
  },
  data() {
    return {
      tiem: 'day2',
      tiems: [
        {
          label: '次日',
          value: 'day2'
        },
        {
          label: '三日',
          value: 'day3'
        },
        {
          label: '七日',
          value: 'day7'
        },
        {
          label: '三十日',
          value: 'day30'
        }
      ],
      lineOptionBuild_: [],
      lineOptions: {
        title: '留存趋势',
        xAxis: {
          name: '时间',
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '百分比',
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        series: [
          {
            name: '留存率',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      },
      login1: false,
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      platformData: [datainfor(11), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      tableList: [],
      loading: true,
      event: 0,
      events: [
        {
          value: 0,
          label: 'total'
        },
        {
          value: 1,
          label: '进入Live'
        },
        {
          value: 2,
          label: '拨打视频通话(成功)'
        },
        {
          value: 3,
          label: '领取宝箱奖励'
        },
        {
          value: 4,
          label: '房间停留时长'
        },
        {
          value: 5,
          label: '赠送礼物'
        },
        {
          value: 6,
          label: '发言'
        },
        {
          value: 7,
          label: '匹配真实通话次数'
        },
        {
          value: 8,
          label: '匹配假视频通话次数'
        },
        {
          value: 9,
          label: '仅进入Live'
        },
        {
          value: 10,
          label: '观看直播间数量'
        }
      ],
      contrastType: 1,
      contrastTypes: [
        {
          label: '>',
          value: 1
        },
        {
          label: '<',
          value: 2
        },
        {
          label: '=',
          value: 3
        }
      ],
      eventValueStart: null,
      eventValueEnd: null,
      language: 'total',
      languageList: '',
      country: 'total',
      countryList: '',
      userType: 0,
      userTypes: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '新用户',
          value: 1
        },
        {
          label: '老用户',
          value: 2
        }
      ],
      isPay: 0,
      isPays: [
        {
          label: 'total',
          value: 0
        },
        {
          label: '非付费用户',
          value: 1
        },
        {
          label: '付费用户',
          value: 2
        }
      ],
      retentionType: 0,
      retentionTypes: [
        {
          label: '产品留存',
          value: 0
        },
        {
          label: '功能留存',
          value: 1
        }
      ],
      page: 1,
      total: 0,
      eventValue: false,
      eventValues: false,
      contrastValue: ''
    }
  },
  beforeCreate() {},
  created() {
    this.languages()
    this.getCountry_()
    this.get_list()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {
    event: {
      handler(newName) {
        if (newName == 4 || newName == 10) {
          this.eventValue = true
          this.eventValueStart = ''
          this.eventValueEnd = ''
        } else {
          this.eventValue = false
        }
        if (newName == 7 || newName == 8) {
          this.eventValues = true
          this.contrastType = 1
          this.contrastValue = ''
        } else {
          this.eventValues = false
        }
      },
      deep: true
    }
  },
  methods: {
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = []
      this.lineOptions.series[0].data = []
      data.forEach(element => {
        this.lineOptions.xAxis.data.push(element.date)
        let a = element.day2.split('%')
        if (this.tiem == 'day3') {
          a = element.day3.split('%')
        }
        if (this.tiem == 'day7') {
          a = element.day7.split('%')
        }
        if (this.tiem == 'day30') {
          a = element.day30.split('%')
        }
        this.lineOptions.series[0].data.push(a[0])
      })
    },
    async languages() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
      }
    },
    async getCountry_() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async get_list() {
      if (this.event != 7 && this.event != 8) {
        this.contrastValue = null
        this.contrastType = null
      }
      this.login1 = true
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_userRetention,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          language: this.language,
          isPay: this.isPay,
          userType: this.userType,
          event: this.event,
          eventValueStart: this.eventValueStart,
          eventValueEnd: this.eventValueEnd,
          contrastValue: this.contrastValue,
          contrastType: this.contrastType,
          retentionType: this.retentionType
        }
      })
      if (res.code == 0) {
        this.login1 = false
        this.lineOptionBuild_ = res.data
        this.lineOptionBuild_s()
        this.tableList = res.data
        this.total = res.data.total
      }
      this.contrastType = 1
    },
    lineOptionBuild_s() {
      this.lineOptionBuild(this.lineOptionBuild_)
    },
    // 分页
    handleCurrentChange(num) {
      this.page = num
      this.get_list()
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.user_userRetention_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.curChannel.selectValue,
          country: this.country,
          isPay: this.isPay,
          language: this.language,
          userType: this.userType,
          event: this.event,
          eventValueStart: this.eventValueStart,
          retentionType: this.retentionType,
          eventValueEnd: this.eventValueEnd
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, 'Live留存数据' + '')
    }
  }
}
</script>


<style lang="stylus" scoped>

.blocked_logs_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;
   
  }
   button {
      margin-left: 30px;
    }

  .display-type {
    margin-top: 20px;
  }
}
</style>
